import React from 'react'

import {
  Divider,
  Button,
  Add as AddIcon,
  Icon,
  Spinner,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

import LegacyDataTable from 'Pods/Shared/DataTable/LegacyDataTable'

import CouponModalForm from './Modal'
import { useCoupons } from '../../../Hooks/useCoupons'
import EmptyMessage from '../../EmptyMessage'

const columnsConfig = {
  id: { visible: false },
  suspended: { visible: false },
  rebate: { visible: false },
  code: { title: 'Code', position: 1 },
  discount: { title: 'Discount', position: 2 },
  validUntil: { title: 'Valid Until', position: 3 },
  timesUsed: { title: 'Times Used', position: 4 },
  action: { title: '', position: 5 },
}

const renderDiscount = (row) => {
  if (row?.discount) {
    return `${row.discount}%`
  }
  if (row?.rebate) {
    return `$${row.rebate}`
  }
  return 'N/A'
}

const renderValidUntil = (value) => {
  if (value === '-') {
    return 'forever'
  }
  return value
}

function Coupons() {
  const {
    coupons,
    isLoading,
    isModalOpen,
    setIsModalOpen,
    handleCreateCoupon,
    handleDeleteCoupon,
  } = useCoupons()

  const renderDeleteButton = (action, row) => {
    return (
      <Button
        onClick={() => handleDeleteCoupon(row.id)}
        type="primary-warning"
        size="tiny"
        customClass="text-sm"
      >
        X
      </Button>
    )
  }

  return (
    <div>
      <div className="cgt-mb-10">
        {isLoading ? (
          <div className="spinner-container">
            <Spinner />
          </div>
        ) : (
          <LegacyDataTable
            data={coupons}
            EmptyMessage={<EmptyMessage title="No coupons available" />}
            columnsConfig={columnsConfig}
            renderCustomCell={{
              validUntil: renderValidUntil,
              action: renderDeleteButton,
              discount: (value, row) => renderDiscount(row),
            }}
          />
        )}
      </div>
      <Divider customClass="cgt-mb-10 cgt-mt-20" />
      <Button
        onClick={() => setIsModalOpen(true)}
        icon={<Icon svgComponent={AddIcon} />}
        type="secondary"
        size="small"
        customClass="text-sm"
      >
        Create new one
      </Button>

      <CouponModalForm
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        handleCreateCoupon={handleCreateCoupon}
      />
    </div>
  )
}

export default Coupons
